<template>
  <div class="whole">
    <div class="nav">
      <el-menu
          :default-active="getSelectedMenuItem()"
          :router="true"
          class="el-menu-demo"
          mode="horizontal"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b">
        <el-menu-item index="/notVerify" @click="handleMenuItemClick('/notVerify')" style="width:33.3%">{{ $t("button.NotVerify") }}</el-menu-item>
        <el-menu-item index="/alreadyVerify" @click="handleMenuItemClick('/alreadyVerify')" style="width: 33.4%">{{ $t("button.AlreadyVerify") }}</el-menu-item>
        <el-menu-item index="/returnVerify" @click="handleMenuItemClick('/returnVerify')" style="width: 33.3%">{{ $t("button.ReturnVerify") }}</el-menu-item>
      </el-menu>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "dataVerifyNav",
  data() {
    return {
    };
  },
  methods: {
    getSelectedMenuItem() {
      // 从本地存储获取上次选择的菜单项
      const selectedMenuItem = localStorage.getItem('selectedMenuItem');
      return selectedMenuItem || '/notVerify'; // 默认为/notVerify
    },
    handleMenuItemClick(item) {
      // 处理菜单项点击事件
      // 设置本地存储中的选中菜单项
      localStorage.setItem('selectedMenuItem', item);
    }
  },
  created() {
  }
}
</script>

<style scoped>
@import "~@/assets/css/sameCss.css";
</style>